import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "form-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "Importer les emails des conducteurs")
], -1)
const _hoisted_3 = { class: "form-content flex-grow" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, " Un email sera envoyé à tous les conducteurs présents dans le fichier qui n'ont pas encore d'email dans geschasse avec un lien pour créér leur mot de passe ", -1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "import-file-input" }, "Fichier excel avec les emails", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "small mt-1" }, " Format du fichier Excel: une colonne Numéro d'adhérent suivie d'une colonne avec l'email ", -1)
const _hoisted_8 = { class: "form-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Aucun email n'a été envoyé, soit aucun des numéros ne correspondaient soit on connaissait déjà les emails de ces personnnes")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("1 email a été envoyé")
const _hoisted_11 = ["disabled"]

import FileUploader from "@/domains/app/components/FileUploader.vue";
import { ref } from "vue";
import { UploadedFile } from "@/domains/app/forms";
import { useLoading } from "@/domains/app/loading";
import { request } from "@/domains/api/api";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const fileToImport = ref<UploadedFile>();
const error = ref<string>();
const emailSent = ref<number>();

function submit() {
    error.value = "";
    if (!fileToImport.value || !fileToImport.value.filename) return;

    const setLoading = useLoading("import-user-emails").setLoading;
    setLoading(true);

    request<{ total: number }>(
        "import/emails",
        "post",
        (err) => (error.value = err.message),
        {
            file: fileToImport.value.filePath,
        }
    )
        .then((data) => {
            emailSent.value = data?.total;
        })
        .finally(() => {
            setLoading(false);
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(FileUploader, {
          id: "import-file-input",
          file: fileToImport.value,
          "onUpdate:file": _cache[0] || (_cache[0] = ($event: any) => ((fileToImport).value = $event)),
          title: "Fichier adhérent - email",
          accept: ".xlsx"
        }, null, 8, ["file"]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (emailSent.value !== undefined)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass({
                    'text-warning': emailSent.value === 0,
                    'text-success': emailSent.value > 0,
                })
          }, [
            (emailSent.value === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_9
                ], 64))
              : (emailSent.value === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_10
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(emailSent.value) + " emails ont été envoyés", 1)
                  ], 64))
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary",
        disabled: !fileToImport.value,
        "loading-key": "import-user-emails"
      }, " Importer les emails ", 8, _hoisted_11)
    ])
  ], 40, _hoisted_1))
}
}

})